import { IAbstractEntity, IAuthorizations, IDeletionConfig, IResourceCollectionResponse, IResourceResponse } from '../interfaces';
import { stripObjectByKeys } from '@kaiser-software/chassis-resource/src/utils/pure-functions';
import { snakeCaseIt } from "case-it"

export class ResponseMapper {

    public static fromGetRequest(response: IResourceResponse): IAbstractEntity {
        // create key,value pairs from attributes
        const attributeValues = Object.values(response.fields).reduce((accumulator, field: any) => {
            if (field.attribute === 'ComputedField') {
                field.attribute = snakeCaseIt(field.name);
            }

            switch (field.component) {
                case 'belongs-to-field':
                    accumulator[
                        this.guessBelongsToForeignKey(field)
                        ] = field.belongsToId;
                    break;
            }

            accumulator[field.attribute] = field.value;

            return accumulator;
        }, {});

        // make fields an array of fields instead of an object of objects
        const fields = Object.values(response.fields);

        return {
            ...attributeValues,
            _id: response.id,
            _fields: fields,
            _deletion_config: ResponseMapper.getDeletionConfig(response),
            _authorizations: ResponseMapper.getEntityAuthorizations(response)
        };
    }

    protected static guessBelongsToForeignKey(field): string {
        return `${field.belongsToRelationship}_id`;
    }

    public static fromUpsertRequest(response: IResourceResponse): IAbstractEntity {
        return {
            ...response,
            _id: response.id,
        };
    }

    //IResourceCollectionResponse
    public static createFromCollectionResponse(response: IResourceCollectionResponse): IAbstractEntity[] {
        // return response;
        return response.resources.map(resource => this.fromGetRequest(resource));
    }

    /**
     * Create an object with authorizations
     *
     * @param response
     */
    public static getEntityAuthorizations(response: IResourceResponse): IAuthorizations {
        return stripObjectByKeys<IAuthorizations>(response, [
            'authorizedToDelete',
            'authorizedToForceDelete',
            'authorizedToRestore',
            'authorizedToUpdate',
            'authorizedToView',
            'authorizedToCreate'
        ]);
    }

    /**
     * Create an object with deletion_config
     *
     * @param response
     */
    public static getDeletionConfig(response: IResourceResponse): IDeletionConfig {
        return stripObjectByKeys<IDeletionConfig>(response, [
            'softDeleted',
            'softDeletes'
        ]);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-resource/src/utils/response-mapper.ts